import { render, staticRenderFns } from "./studentMessage.vue?vue&type=template&id=bed23758&scoped=true"
import script from "./studentMessage.vue?vue&type=script&lang=js"
export * from "./studentMessage.vue?vue&type=script&lang=js"
import style0 from "./studentMessage.vue?vue&type=style&index=0&id=bed23758&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bed23758",
  null
  
)

export default component.exports